// import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

// export const firstClockInAfterShiftStartValidator: ValidatorFn = (
//   control: AbstractControl
// ): ValidationErrors | null => {
//   const shiftStartTime = control.get('shiftStartTime')?.value
//   const firstClockInTime = control.get('firstClockInTime')?.value

//   if (!shiftStartTime || !firstClockInTime) {
//     return null // validation handled elsewhere
//   }

//   // Convert HH:mm → minutes
//   const toMinutes = (time: string) => {
//     const [h, m] = time.split(':').map(Number)
//     return h * 60 + m
//   }

//   return toMinutes(firstClockInTime) < toMinutes(shiftStartTime)
//     ? { firstClockInBeforeShift: true }
//     : null
// }



import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export const firstClockInAfterShiftStartValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const shiftStartTime = control.get('shiftStartTime')?.value
  const graceMinutes = control.get('firstClockInTime')?.value

  if (!shiftStartTime || graceMinutes === null || graceMinutes === undefined) {
    return null
  }

  // Convert shift start (HH:mm) → minutes
  const [shiftHour, shiftMin] = shiftStartTime.split(':').map(Number)
  const shiftStartTotal = shiftHour * 60 + shiftMin

  // Grace is already in minutes
  const graceEnd = shiftStartTotal + Number(graceMinutes)



  // Example validation (optional):
  if (graceMinutes < 0) {
    return { invalidGraceMinutes: true }
  }

  return null
}